import React from 'react';
import { TextButton, Icon } from '../../../../design-system';
import { CTAsWrapper, InventoryCTA, MainCta, BuildCtaAlpha } from './VehicleTile.styles';
import { useTranslation } from 'react-i18next';
import { IS_TIER_1 } from '../../../constants/environment';

interface CTAsProps {
  inventoryUrl: string;
  digitalLeadsInfo: string;
  configuratorUrl?: string | null;
}

const VehicleTileCTAs: React.FC<CTAsProps> = ({
  inventoryUrl,
  digitalLeadsInfo,
  configuratorUrl,
}) => {
  const { t } = useTranslation();
  const isAlpha = !process.env.IS_LEGACY;

  return (
    <CTAsWrapper>
      {isAlpha ? (
        <>
          <TextButton
            href={inventoryUrl}
            variant="secondary"
            icon="external-link"
            iconPosition="trailing"
            target="_blank"
            isFullWidth
            data-testid="offer-inventory-cta"
          >
            {t('promo.offers.cta.inventory')}
          </TextButton>
          <TextButton
            variant="secondary"
            onClick={() => {}}
            isFullWidth
            id="digital-leads"
            data-info={digitalLeadsInfo}
            data-testid="offer-contact-cta"
          >
            {t('promo.offers.cta.contact')}
          </TextButton>
          {IS_TIER_1 && configuratorUrl && (
            <BuildCtaAlpha
              href={configuratorUrl}
              variant="standalone"
              size="md"
              data-testid="build-cta"
              target="_blank"
            >
              Build Your Audi <Icon name="external-link" size="s" />
            </BuildCtaAlpha>
          )}
        </>
      ) : (
        <>
          <InventoryCTA
            data-testid="offer-inventory-cta"
            variant="secondary"
            href={inventoryUrl}
            iconPosition="trailing"
            icon="external-link"
            target="_blank"
            isFullWidth
          >
            {t('promo.offers.cta.inventory')}
          </InventoryCTA>
          <MainCta id="digital-leads" data-info={digitalLeadsInfo} data-testid="offer-contact-cta">
            {t('promo.offers.cta.contact')}
          </MainCta>
        </>
      )}
    </CTAsWrapper>
  );
};

export default VehicleTileCTAs;
